export const CLOSE_DROPDOWN_EVENT = 'eag-close-dropdown' as const;
